import clsx from 'clsx';
import React from 'react';

export const DrawerSideBox: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={clsx('drawer', 'flex-col', 'flex', 'relative', 'h-screen', 'text-white')}>{children}</div>;
};
